import { FulfillmentGroupStatus } from "@redotech/redo-model/fulfillments/fulfillment-group-status";
import { unaryRpc } from "@redotech/rpc/definition";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const inboundShipmentLineItemSchema_ = z.object({
  title: z.string(),
  productTitle: z.string(),
  sku: z.string().nullable(),
  quantity: z.number(),
});
export const inboundShipmentLineItemSchema: z.ZodType<InboundShipmentLineItem> =
  inboundShipmentLineItemSchema_;
export interface InboundShipmentLineItem
  extends z.infer<typeof inboundShipmentLineItemSchema_> {}

const inboundShipmentDestinationSchema_ = z.object({
  name: z.string(),
  address1: z.string().nullable(),
  address2: z.string().nullable(),
  city: z.string().nullable(),
  province: z.string().nullable(),
  zip: z.string().nullable(),
  countryCode: z.string().nullable(),
});
export const inboundShipmentDestinationSchema: z.ZodType<InboundShipmentDestination> =
  inboundShipmentDestinationSchema_;
export interface InboundShipmentDestination
  extends z.infer<typeof inboundShipmentDestinationSchema_> {}

const inboundShipmentSchema_ = z.object({
  id: z.string(),
  orderName: z.string(),
  status: createEnum(FulfillmentGroupStatus, {
    enumName: "FulfillmentGroupStatus",
  }),
  carrier: z.string().nullable(),
  trackingCode: z.string().nullable(),
  trackingUrl: z.string().nullable(),
  itemCount: z.number(),
  lineItems: z.array(inboundShipmentLineItemSchema),
  destination: inboundShipmentDestinationSchema,
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const inboundShipmentSchema: z.ZodType<InboundShipment> =
  inboundShipmentSchema_;
export interface InboundShipment
  extends z.infer<typeof inboundShipmentSchema_> {}

export const listInboundConsolidatedShipments = unaryRpc({
  name: "listInboundConsolidatedShipments" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    statuses: z
      .array(
        createEnum(FulfillmentGroupStatus, {
          enumName: "FulfillmentGroupStatus",
        }),
      )
      .optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(200).default(25),
  }),
  output: z.object({
    items: z.array(inboundShipmentSchema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});

export type InboundShipmentsOutput = z.infer<
  (typeof listInboundConsolidatedShipments)["output"]
>;
